import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
import OrderInfo from './OrderInfo';
import * as orderActions from './../../../../../../actions/orderAction';
import { updateOrderStatus } from "./../../../../../../actions/orderAction";

const mapStateToProps = state => {
    return {
        orderState: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openModalDetail: () => dispatch(orderActions.openModalDetail()),
        recommitTourOrder: (id) => dispatch(orderActions.recommitTourOrder(id)),
        updateOrderStatus: (order) =>  dispatch(orderActions.updateOrderStatus(order)),
        recommitHotelBundle: (data) =>  dispatch(orderActions.recommitHotelBundle(data)),
        getOrderDetail: (id) => dispatch(orderActions.getOrderDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderInfo));
